import { doDelete, doGet, doPost } from "../../../api/baseAPI";
import { GROLOG_URL } from "../../../constant/apiConstant";
import { setTableLoading } from "../../../store/reducer/page.reducer";
import { checkValidationToken } from "../../../util/errorHandler";


export const listInvitation = async (token, refresh_token, param, dispatch) => {
  const url = `${GROLOG_URL}/invitation?${param}`;
  const initiateUrl = `${GROLOG_URL}/invitation/initiate?${param}`;
  let result = { list: undefined, ok: false, initiate: undefined }

  dispatch(setTableLoading(true))
  try {
    const res = await doGet(token, url, null);
    const resInitiate = await doGet(token, initiateUrl);

    if ((res?.status && resInitiate?.status) === 200) {
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.initiate = resInitiate?.data?.payload?.data;
    }
  } catch (error) {
    checkValidationToken(error, token, refresh_token, dispatch)
  }
  dispatch(setTableLoading(false))
  return result
}

export const listRole = async (token, refresh_token, page, limit, dispatch, keyword = '') => {
  let result = { list: undefined, ok: false }
  const url = `${GROLOG_URL}/role/search`;
  const params = { page, limit, filter: keyword !== '' ? `role_id lk ${keyword}` : '' }

  dispatch(setTableLoading(true));
  try {
    const response = await doGet(token, url, params)

    if (response) {
      result.ok = true
      result.list = response?.data?.payload?.data
    }
  } catch (error) {
    checkValidationToken(error, token, refresh_token, dispatch)
  }

  dispatch(setTableLoading(false))
  return result
}

export const listDataGroup = async (token, refresh_token, page, limit, dispatch, keyword) => {
  let result = { list: undefined, ok: false }
  const url = `${GROLOG_URL}/data-group/search`;
  const params = { page, limit, filter: keyword !== '' ? `data_group_id lk ${keyword}` : ''  }

  dispatch(setTableLoading(true));
  try {
    const response = await doGet(token, url, params)

    if (response) {
      result.ok = true
      result.list = response?.data?.payload?.data
    }
  } catch (error) {
    checkValidationToken(error, token, refresh_token, dispatch)
  }

  dispatch(setTableLoading(false))
  return result
}

export const insert = async (token, refresh_token, data, params, dispatch) => {
  const result = { status: false, message: undefined }
  const url = `${GROLOG_URL}/invitation`

  try {
    const res = await doPost(url, token, data, params)
    if (res) {
      result.status = true
      result.message = res.data.payload.message
    } else {
      result.status = false
      result.message = res.data.payload.message
    }
  } catch (error) {
    result.message = error.response.data.payload.message
    checkValidationToken(error, token, refresh_token, dispatch)
  }

  return result
}

export const getSearchRecommendation = async (token, refresh_token, keyword, dispatch) => {
  const url = `${GROLOG_URL}/invitation/search?page=1&limit=10&filter=email lk ${keyword}`;
  let result = { data: undefined, ok: false }

  try {
    const response = await doGet(token, url, null);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload?.data
    }
  } catch (error) {
    checkValidationToken(error, token, refresh_token, dispatch)
  }
  return result
}

export const getSearchResult = async (token, refresh_token, keyword, dispatch) => {
  const url = `${GROLOG_URL}/invitation?page=1&limit=10&filter=email eq ${keyword}`;
  let result = { data: undefined, ok: false }

  dispatch(setTableLoading(true))
  try {
    const response = await doGet(token, url, null);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload?.data
    }
  } catch (error) {
    checkValidationToken(error, token, refresh_token, dispatch)
  }
  dispatch(setTableLoading(false))
  return result
}

export const initiateInvitation = async (token, refresh_token, param, dispatch) => {

  const url = `${GROLOG_URL}/invitation/initiate?${param}`;
  let result = { data: undefined, ok: false }

  dispatch(setTableLoading(true))
  try {
    const response = await doGet(token, url, null);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload?.data
    }
  } catch (error) {
    checkValidationToken(error, token, refresh_token, dispatch)
  }
  dispatch(setTableLoading(false))
  return result
}

export const deleteInvitation = async (token, refresh_token, id, updated_at, dispatch) => {
  const url = `${GROLOG_URL}/invitation/${id}`
  let result = { data: undefined, ok: false }

  let data = {
      'updated_at': updated_at
  }

  try {
      const response = await doDelete(url, token, data)
      if (response) {
          result.ok = true
          result.data = response?.data?.payload?.data
      }
  } catch (error) {
      checkValidationToken(error, token, refresh_token, dispatch)
  }
  return result
}